import React from "react";
import AllTopics from "./components/allTopics";
import MostRead from "./components/mostRead";
import MainSection from "./components/mainSection";
import { Tabs, Button } from "flowbite-react";
import ArcheiveCount from "./components/archeiveCount";
import RecentArticles from "./components/recentArticles";
import FeaturedList from "./components/featuredList";
import BlogDetails from "./components/blogDetailsPage";
import BlogNotFound from "image/blog/cat.svg";
import Image from "next/image";
import API from "src/utils/apiHelper";

interface BlogPageProps {
  mostRead: any;
  allBlog?: any;
  featuredBlog: any;
  categoryCount: any;
  archeiveCount: any;
  isDetailsPage?: boolean;
  blogDetails?: object;
  allCommentData?: any;
  isCategoriesPage?: boolean;
  reqHeader?: string;
}

const BlogPage = ({
  allBlog,
  mostRead,
  featuredBlog,
  categoryCount,
  archeiveCount,
  blogDetails,
  allCommentData,
  isCategoriesPage = false,
  isDetailsPage = false,
  reqHeader = "",
}: BlogPageProps) => {
  const tabsRef = React.useRef(null);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [isLoading, setIsLoading] = React.useState(false);
  const [allTopics, setAllTopics] = React.useState(allBlog?.dataList || []);
  const [mostReadBlog, setMostReadBlog] = React.useState(
    mostRead?.dataList || []
  );
  const [categoryList, setCategoryList] = React.useState(categoryCount || []);
  const [featureListBlog, setFeatureListBlog] = React.useState(
    featuredBlog?.dataList || []
  );

  React.useEffect(() => {
    if (allBlog?.dataList?.length) {
      setCurrentPage(1);
      setAllTopics(allBlog?.dataList);
    }
  }, [allBlog?.dataList]);
  const handleLoadMore = async () => {
    setIsLoading(true);
    await API.getData(
      reqHeader.replace("page=1", `page=${currentPage + 1}`)
    ).then((result) => {
      if (result.status === 200) {
        setAllTopics([...allTopics, ...result?.data?.dataList]);
        setCurrentPage(currentPage + 1);
        setIsLoading(false);
      }
    });
  };
  return (
    <section>
      <div className="container mx-auto ">
        <AllTopics data={categoryList} />

        <div className="grid gap-8 lg:grid-cols-4">
          <div className="p-4 bg-white rounded-md lg:col-span-3 dark:bg-dark-bg-secondary">
            {isCategoriesPage ? (
              <RecentArticles data={allTopics} />
            ) : !isDetailsPage ? (
              <>
                <MainSection
                  data={featureListBlog[0] || {}}
                  featuredBlog={featureListBlog}
                />
                <RecentArticles data={allTopics} />
              </>
            ) : (
              <BlogDetails data={blogDetails || {}} />
            )}
            {(allBlog?.totalItems > 6 &&
              allTopics.length < allBlog?.totalItems && (
                <div className="flex justify-center">
                  {isLoading ? (
                    <div className="spinner">
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  ) : (
                    <p
                      onClick={() => handleLoadMore()}
                      className="w-[fit-content] px-4 p-1 mt-8  rounded-full border cursor-pointer  hover:text-button-100 text-sm"
                    >
                      Load More
                    </p>
                  )}
                </div>
              )) ||
              ""}
          </div>
          <div className="bg-white dark:bg-dark-bg-secondary rounded-md p-4 h-[fit-content]">
            <MostRead data={mostReadBlog} />
            <ArcheiveCount data={archeiveCount || []} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogPage;
